/* eslint-disable @typescript-eslint/naming-convention */
export enum tensesEnum {
    past,
    present,
    future
}
